import { Link } from 'react-router-dom';
import { categories, mainSiteUrl, articleLinks } from '@/mocks/categories';

export default function Footer() {
  const firstHalf = categories.slice(0, 7);
  const secondHalf = categories.slice(7);

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left Column */}
          <div className="lg:w-[40%]">
            <Link to="/" className="inline-flex items-center gap-2 group mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-base"></i>
              </div>
              <span className="text-lg font-semibold text-foreground-900 font-heading">
                USFansSpreadsheet
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4 max-w-sm">
              Twój kompletny przewodnik po usfansspreadsheet. Znajdziesz tutaj porównania, poradniki, analizy bezpieczeństwa i najlepsze rozwiązania dla arkuszy kalkulacyjnych.
            </p>
            <p className="text-xs text-foreground-400 mb-8">
              © {new Date().getFullYear()} usfansspreadsheet.work. Wszelkie prawa zastrzeżone.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/artykul/co-to-jest-usfansspreadsheet"
                className="px-4 py-2 text-xs font-medium text-foreground-600 border border-background-300/80 rounded-full hover:border-accent-500 hover:text-accent-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Przewodnik
              </Link>
              <Link
                to="/artykul/czy-usfansspreadsheet-jest-bezpieczny"
                className="px-4 py-2 text-xs font-medium text-foreground-600 border border-background-300/80 rounded-full hover:border-accent-500 hover:text-accent-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Bezpieczeństwo
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 text-xs font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Odwiedź platformę
              </a>
            </div>
          </div>

          {/* Right Column - Category Links */}
          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
                  Strona główna
                </Link>
              </h4>
              <div className="flex flex-col gap-2.5">
                {firstHalf.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.namePl}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <Link to="/artykul/co-to-jest-usfansspreadsheet" className="hover:text-primary-600 transition-colors cursor-pointer">
                  Artykuły
                </Link>
              </h4>
              <div className="flex flex-col gap-2.5">
                {secondHalf.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.namePl}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                Poradniki
              </h4>
              <div className="flex flex-col gap-2.5">
                {articleLinks.slice(0, 5).map((article) => (
                  <Link
                    key={article.slug}
                    to={`/artykul/${article.slug}`}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                  >
                    {article.title.length > 40 ? article.title.slice(0, 40) + '...' : article.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}